import {protectedWhatsAppFetch} from "../services/protectedWhatsApp";
import {useAccess} from "../access/useAccess";
import {clinicSettingsPayload} from "../access/settings";
import {
  useEffect,
  useState
} from "react";

import {
  doc,
  getDoc,
  updateDoc
} from "../access/firestore";

import {
  db,
  auth,
  storage
} from "../firebase";

import {
  getNotificationPreferences,
  updateNotificationPreferences
} from "../notifications/pushNotifications";

import {
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import {
  useClinic
} from "../context/ClinicContext";

import MobileProceduresSettings 
  from "./MobileProceduresSettings";

import MobileHistoriaClinicaSettings 
  from "./MobileHistoriaClinicaSettings";

import MobileConsentimientosSettings 
  from "./MobileConsentimientosSettings";

import MobileMedicamentosSettings 
  from "./MobileMedicamentosSettings";

import MobileIntegracionesSettings 
  from "./MobileIntegracionesSettings";

import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
} from "firebase/auth";

import {
  QRCodeSVG
} from "qrcode.react";

import ComunicacionCampanasPanel
  from "../components/settings/ComunicacionCampanasPanel";

import AdvancedClinicSettings
  from "../components/settings/AdvancedClinicSettings";

import {
  Clock3,
  Megaphone,
  Stethoscope,
  ClipboardList,
  FileSignature,
  Pill,
  PlugZap,
  BellRing,
  UserRound,
  MonitorCog,
  ChevronRight,
  MessageCircle,
  CalendarPlus,
  CalendarClock,
  CalendarX2,
  CircleCheck,
  SlidersHorizontal
} from "lucide-react";


const DEFAULT_HORARIOS = {

  lunes: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  martes: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  miercoles: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  jueves: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  viernes: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  sabado: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "",
    comidaFin: "",
    cierre: "14:00"
  },

  domingo: {
    activo: false,
    apertura: "09:00",
    comidaInicio: "",
    comidaFin: "",
    cierre: "14:00"
  }

};


const DEFAULT_NOTIFICATIONS = {

  reminder24h: true,
  reminder2h: false,
  autoConfirm: true,
  cancelledAppointment: true,
  whatsappMessages: true

};


export default function MobileSettingsPanel() {
  const {can}=useAccess();


  const {
    clinicId,
    clinicData
  } = useClinic();


  const [
    activeSection,
    setActiveSection
  ] = useState("menu");


  const [
    form,
    setForm
  ] = useState({

    nombreClinica: "",
    telefono: "",
    email: "",
    RFC: "",

    direccion: {

      calle: "",
      numeroExterior: "",
      numeroInterior: "",
      codigoPostal: "",
      colonia: "",
      ciudad: "",
      estado: "",
      pais: "México"

    },

    logoURL: "",
    logoBase64: "",

    horaApertura: "09:00",
    horaCierre: "18:00",

    intervaloAgenda: "15",

    defaultAppointmentDuration: "60",

    horariosLaborales:
      DEFAULT_HORARIOS,

    whatsappEnabled: false,

    whatsappBusinessName: "",
    whatsappNumber: "",

    notifications:
      DEFAULT_NOTIFICATIONS,

    timeZone:
      Intl.DateTimeFormat()
        .resolvedOptions()
        .timeZone

  });


  const [
    saving,
    setSaving
  ] = useState(false);


  const [
    uploadingLogo,
    setUploadingLogo
  ] = useState(false);


  const [
    message,
    setMessage
  ] = useState(null);

  const [
    accountData,
    setAccountData
  ] = useState(null);

  const [
    systemUserSettings,
    setSystemUserSettings
  ] = useState({
    firmaPersonalizada: "",
    useCustomSignature: false
  });

    const [
    googleCalendarSystem,
    setGoogleCalendarSystem
    ] = useState({
    connected: false,
    email: ""
    });

    const [
    vpsOnline,
    setVpsOnline
    ] = useState(false);

    const [
    showMobileAppModal,
    setShowMobileAppModal
    ] = useState(false);

  const [
    currentPassword,
    setCurrentPassword
  ] = useState("");

    const [
    newPassword,
    setNewPassword
  ] = useState("");

    const [
    confirmPassword,
    setConfirmPassword
  ] = useState("");

    const [
    changingPassword,
    setChangingPassword
  ] = useState(false);

    const [
    passwordMessage,
    setPasswordMessage
  ] = useState("");

    const [
    passwordError,
    setPasswordError
  ] = useState("");

    const [
    userNotificationPreferences,
    setUserNotificationPreferences
  ] = useState({
    whatsappMessages: true,
    newAppointment: true,
    appointmentReminder15m: true
  });

  useEffect(() => {

    const uid = auth.currentUser?.uid;

    if (!uid || !clinicId) {
        setAccountData(null);
        return;
    }

    const cargarCuenta = async () => {

        try {

        const snapshot = await getDoc(
            doc(
            db,
            "clinics",
            clinicId,
            "users",
            uid
            )
        );

        setAccountData(
            snapshot.exists()
            ? snapshot.data()
            : null
        );

        } catch (error) {

        console.error(
            "Error cargando información de cuenta:",
            error
        );

        setAccountData(null);

        }

    };

    cargarCuenta();

  }, [clinicId]);

  useEffect(() => {

    const uid = auth.currentUser?.uid;

    if (!uid) {
        return;
    }

    const cargarSistema = async () => {

        try {

        const usuarioSnapshot = await getDoc(
            doc(
            db,
            "users",
            uid
            )
        );

        if (usuarioSnapshot.exists()) {

            const data =
            usuarioSnapshot.data();

            setSystemUserSettings({
            firmaPersonalizada:
                data.firmaPersonalizada || "",
            useCustomSignature:
                data.useCustomSignature || false
            });

        }

        } catch (error) {

        console.error(
            "Error cargando configuración del sistema:",
            error
        );

        }

    };

    cargarSistema();

  }, []);

  useEffect(() => {

    if (!clinicId) {
        return;
    }

    const cargarIntegracionesSistema =
        async () => {

        try {

            const googleSnapshot =
            await getDoc(
                doc(
                db,
                "clinics",
                clinicId,
                "integrations",
                "googleCalendar"
                )
            );

            if (googleSnapshot.exists()) {

            const data =
                googleSnapshot.data();

            setGoogleCalendarSystem({
                connected:
                data.connected || false,
                email:
                data.email || ""
            });

            } else {

            setGoogleCalendarSystem({
                connected: false,
                email: ""
            });

            }

        } catch (error) {

            console.error(
            "Error cargando Google Calendar:",
            error
            );

        }

        };

    cargarIntegracionesSistema();

    const verificarVPS =
        async () => {

        try {

            const response =
            await protectedWhatsAppFetch(
                `https://wa.vexadent.com/health?clinicId=${clinicId}`
            );

            setVpsOnline(
            response.ok
            );

        } catch (error) {

            console.error(
            "Error verificando WhatsApp VPS:",
            error
            );

            setVpsOnline(false);

        }

        };

    verificarVPS();

  }, [clinicId]);

  const [
    colonias,
    setColonias
  ] = useState([]);


  useEffect(() => {

    if (!clinicData)
      return;


    setForm({

      nombreClinica:
        clinicData.nombreClinica || "",

      telefono:
        clinicData.telefono || "",

      email:
        clinicData.email || "",

      RFC:
        clinicData.RFC || "",

      direccion:
        clinicData.direccion || {

          calle: "",
          numeroExterior: "",
          numeroInterior: "",
          codigoPostal: "",
          colonia: "",
          ciudad: "",
          estado: "",
          pais: "México"

        },

      logoURL:
        clinicData.logoURL || "",

      logoBase64:
        clinicData.logoBase64 || "",

      horaApertura:
        clinicData.horaApertura || "09:00",

      horaCierre:
        clinicData.horaCierre || "18:00",

      intervaloAgenda:
        clinicData.intervaloAgenda || "15",

      defaultAppointmentDuration:
        clinicData.defaultAppointmentDuration ||
        "60",

      horariosLaborales:
        clinicData.horariosLaborales ||
        DEFAULT_HORARIOS,

      whatsappEnabled:
        clinicData.whatsappEnabled ||
        false,

      whatsappBusinessName:
        clinicData.whatsappBusinessName ||
        "",

      whatsappNumber:
        clinicData.whatsappNumber ||
        "",

      notifications:
        clinicData.notifications ||
        DEFAULT_NOTIFICATIONS,

      timeZone:
        clinicData.timeZone ||
        Intl.DateTimeFormat()
          .resolvedOptions()
          .timeZone

    });

  }, [clinicData]);


  useEffect(() => {

    const cp =
      form.direccion?.codigoPostal || "";


    if (cp.length !== 5)
      return;


    const buscarCP = async () => {

      try {

        const response =
          await fetch(
            `https://api.zippopotam.us/mx/${cp}`
          );


        if (!response.ok)
          return;


        const data =
          await response.json();


        const places =
          data.places || [];


        const listaColonias =
          places.map(
            place =>
              place["place name"]
          );


        setColonias(
          listaColonias
        );


        setForm(prev => ({

          ...prev,

          direccion: {

            ...prev.direccion,

            colonia:
              prev.direccion.colonia ||
              listaColonias[0] ||
              "",

            estado:
              places[0]?.state ||
              prev.direccion.estado ||
              ""

          }

        }));

      } catch (error) {

        console.error(
          "Error buscando CP:",
          error
        );

      }

    };


    buscarCP();

  }, [
    form.direccion?.codigoPostal
  ]);

    useEffect(() => {

        const cargarPreferenciasNotificaciones =
        async () => {

            try {

            const preferences =
                await getNotificationPreferences();

            if (preferences) {

                setUserNotificationPreferences(
                prev => ({
                    ...prev,
                    ...preferences
                })
                );

            }

            } catch (error) {

            console.error(
                "Error cargando preferencias de notificaciones:",
                error
            );

            }

        };

        cargarPreferenciasNotificaciones();

    }, []);

  const handleChange = (
    event
  ) => {

    const {
      name,
      value
    } = event.target;


    setForm(prev => ({

      ...prev,

      [name]: value

    }));

  };


  const handleDireccionChange = (
    field,
    value
  ) => {

    setForm(prev => ({

      ...prev,

      direccion: {

        ...prev.direccion,

        [field]: value

      }

    }));

  };


  const handleHorarioChange = (
    dia,
    campo,
    valor
  ) => {

    setForm(prev => ({

      ...prev,

      horariosLaborales: {

        ...prev.horariosLaborales,

        [dia]: {

          ...prev.horariosLaborales[dia],

          [campo]: valor

        }

      }

    }));

  };


  const fileToBase64 = file => {

    return new Promise(
      (resolve, reject) => {

        const reader =
          new FileReader();


        reader.readAsDataURL(
          file
        );


        reader.onload =
          () => resolve(
            reader.result
          );


        reader.onerror =
          error =>
            reject(error);

      }
    );

  };


  const subirLogo = async event => {

    const file =
      event.target.files?.[0];


    if (!file)
      return;


    if (!clinicId)
      return;


    try {

      setUploadingLogo(true);


      const storageRef =
        ref(
          storage,
          `logos/${clinicId}`
        );


      await uploadBytes(
        storageRef,
        file
      );


      const url =
        await getDownloadURL(
          storageRef
        );


      const logoBase64 =
        await fileToBase64(
          file
        );


      setForm(prev => ({

        ...prev,

        logoURL: url,
        logoBase64

      }));


      setMessage({

        type: "success",

        text:
          "Logo actualizado. Guarda los cambios."

      });

    } catch (error) {

      console.error(
        error
      );


      setMessage({

        type: "error",

        text:
          "No fue posible subir el logo."

      });

    } finally {

      setUploadingLogo(false);

    }

  };


  const guardar = async () => {

    if (!clinicId)
      return;


    try {

      setSaving(true);


      (can("settings","clinic")||can("settings","whatsappConfig")) && await updateDoc(

        doc(
          db,
          "clinics",
          clinicId
        ),

        clinicSettingsPayload({

          nombreClinica:
            form.nombreClinica,

          telefono:
            form.telefono,

          email:
            form.email,

          RFC:
            form.RFC,

          direccion:
            form.direccion,

          logoURL:
            form.logoURL,

          logoBase64:
            form.logoBase64 ||
            clinicData?.logoBase64 ||
            null,

          horaApertura:
            form.horaApertura,

          horaCierre:
            form.horaCierre,

          intervaloAgenda:
            form.intervaloAgenda,

          defaultAppointmentDuration:
            form.defaultAppointmentDuration,

          horariosLaborales:
            form.horariosLaborales,

          whatsappEnabled:
            form.whatsappEnabled,

          whatsappBusinessName:
            form.whatsappBusinessName,

          whatsappNumber:
            form.whatsappNumber,

          notifications:
            form.notifications,

          timeZone:
            form.timeZone

        },can)

      );


      setMessage({

        type: "success",

        text:
          "Configuración guardada correctamente."

      });


      setTimeout(
        () => setMessage(null),
        3000
      );

    } catch (error) {

      console.error(
        error
      );


      setMessage({

        type: "error",

        text:
          "No fue posible guardar la configuración."

      });

    } finally {

      setSaving(false);

    }

  };


  const actualizarNotificacion = (
    key,
    value
  ) => {

    setForm(prev => ({

      ...prev,

      notifications: {

        ...prev.notifications,

        [key]: value

      }

    }));

  };


  const actualizarWhatsApp = (
    field,
    value
  ) => {

    setForm(prev => ({

      ...prev,

      [field]: value

    }));

  };


  const secciones = [

    {
        id: "control",
        titulo: "Configuración completa",
        descripcion:
        "Controla todos los módulos de tu consultorio",
        icono: SlidersHorizontal
    },

    {
        id: "procedimientos",
        titulo: "Procedimientos",
        descripcion:
        "Catálogo y configuración de procedimientos",
        icono: Stethoscope
    },

    {
        id: "historia",
        titulo: "Historia clínica",
        descripcion:
        "Campos y estructura de la historia clínica",
        icono: ClipboardList
    },

    {
        id: "consentimientos",
        titulo: "Consentimientos",
        descripcion:
        "Consentimientos informados",
        icono: FileSignature
    },

    {
        id: "medicamentos",
        titulo: "Medicamentos",
        descripcion:
        "Catálogo y posología",
        icono: Pill
    },

    {
        id: "integraciones",
        titulo: "Integraciones",
        descripcion:
        "WhatsApp y calendarios",
        icono: PlugZap
    },

    {
      id: "comunicacion",
      titulo: "Comunicación y campañas",
      descripcion:
        "Cumpleaños, festividades y promociones",
      icono: Megaphone
    },

    {
        id: "cuenta",
        titulo: "Mi cuenta",
        descripcion:
        "Datos y seguridad de tu cuenta",
        icono: UserRound
    },

    {
        id: "sistema",
        titulo: "Sistema",
        descripcion:
        "Opciones generales del sistema",
        icono: MonitorCog
    }

  ];


  const renderGeneral = () => (

    <div>

      <SectionHeader
        titulo="General"
        descripcion="Configura los datos principales de tu consultorio."
        onBack={() =>
          setActiveSection("menu")
        }
      />


      <Card>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 14
        }}>

          {form.logoURL ? (

            <img
              src={form.logoURL}
              alt="Logo"
              style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                objectFit: "cover",
                border:
                  "1px solid #e5e7eb"
              }}
            />

          ) : (

            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                background: "#2563eb",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 28,
                fontWeight: 800
              }}
            >
              V
            </div>

          )}


          <div style={{
            flex: 1
          }}>

            <div style={{
              fontSize: 15,
              fontWeight: 700,
              marginBottom: 8
            }}>
              Logo del consultorio
            </div>


            <label
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding:
                  "10px 14px",
                borderRadius: 10,
                background:
                  "#eff6ff",
                color:
                  "#2563eb",
                fontWeight: 700,
                fontSize: 13,
                cursor:
                  "pointer"
              }}
            >

              {uploadingLogo
                ? "Subiendo..."
                : "Cambiar logo"}

              <input
                type="file"
                accept="image/*"
                onChange={
                  subirLogo
                }
                style={{
                  display: "none"
                }}
              />

            </label>

          </div>

        </div>

      </Card>


      <Card>

        <Field
          label="Nombre del consultorio"
          value={
            form.nombreClinica
          }
          onChange={event =>
            handleChange(event)
          }
          name="nombreClinica"
        />


        <Field
          label="Teléfono"
          value={
            form.telefono
          }
          onChange={event =>
            handleChange(event)
          }
          name="telefono"
          type="tel"
        />


        <Field
          label="Correo"
          value={
            form.email
          }
          onChange={event =>
            handleChange(event)
          }
          name="email"
          type="email"
        />


        <Field
          label="RFC"
          value={
            form.RFC
          }
          onChange={event =>
            handleChange(event)
          }
          name="RFC"
        />

      </Card>


      <Card>

        <CardTitle>
          Dirección
        </CardTitle>


        <Field
          label="Calle"
          value={
            form.direccion.calle
          }
          onChange={event =>
            handleDireccionChange(
              "calle",
              event.target.value
            )
          }
        />


        <div style={{
          display: "grid",
          gridTemplateColumns:
            "1fr 1fr",
          gap: 12
        }}>

          <Field
            label="No. exterior"
            value={
              form.direccion
                .numeroExterior
            }
            onChange={event =>
              handleDireccionChange(
                "numeroExterior",
                event.target.value
              )
            }
          />


          <Field
            label="No. interior"
            value={
              form.direccion
                .numeroInterior
            }
            onChange={event =>
              handleDireccionChange(
                "numeroInterior",
                event.target.value
              )
            }
          />

        </div>


        <Field
          label="Código postal"
          value={
            form.direccion
              .codigoPostal
          }
          onChange={event =>
            handleDireccionChange(
              "codigoPostal",
              event.target.value
            )
          }
          type="tel"
        />


        <Field
          label="Colonia"
          value={
            form.direccion.colonia
          }
          onChange={event =>
            handleDireccionChange(
              "colonia",
              event.target.value
            )
          }
        />


        <Field
          label="Ciudad"
          value={
            form.direccion.ciudad
          }
          onChange={event =>
            handleDireccionChange(
              "ciudad",
              event.target.value
            )
          }
        />


        <Field
          label="Estado"
          value={
            form.direccion.estado
          }
          onChange={event =>
            handleDireccionChange(
              "estado",
              event.target.value
            )
          }
        />

      </Card>


      <Card>

        <CardTitle>
          Agenda
        </CardTitle>


        <Field
          label="Zona horaria de respaldo"
          value={
            form.timeZone
          }
          onChange={event =>
            handleChange(event)
          }
          name="timeZone"
        />

        <p style={{margin:"-8px 0 16px",color:"#71809a",fontSize:12,lineHeight:1.45}}>
          Las citas nuevas detectan la zona horaria de cada dispositivo automáticamente. Este valor conserva compatibilidad con citas antiguas.
        </p>


        <SelectField
          label="Intervalo de agenda"
          value={
            form.intervaloAgenda
          }
          onChange={event =>
            handleChange(event)
          }
          name="intervaloAgenda"
          options={[
            ["15", "15 minutos"],
            ["30", "30 minutos"],
            ["60", "60 minutos"]
          ]}
        />


        <SelectField
          label="Duración predeterminada de cita"
          value={
            form.defaultAppointmentDuration
          }
          onChange={event =>
            setForm(prev => ({

              ...prev,

              defaultAppointmentDuration:
                event.target.value

            }))
          }
          options={[
            ["15", "15 minutos"],
            ["30", "30 minutos"],
            ["45", "45 minutos"],
            ["60", "60 minutos"],
            ["90", "90 minutos"],
            ["120", "120 minutos"]
          ]}
        />

      </Card>


      <SaveButton
        saving={saving}
        onClick={guardar}
      />

    </div>

  );


  const renderHorarios = () => {
    const dias = [
        { id: "lunes", nombre: "Lunes" },
        { id: "martes", nombre: "Martes" },
        { id: "miercoles", nombre: "Miércoles" },
        { id: "jueves", nombre: "Jueves" },
        { id: "viernes", nombre: "Viernes" },
        { id: "sabado", nombre: "Sábado" },
        { id: "domingo", nombre: "Domingo" }
    ];

    return (
        <div>
        <SectionHeader
            titulo="Horarios laborales"
            descripcion="Configura los días y horarios de atención del consultorio."
            onBack={() => setActiveSection("menu")}
        />

        <div
            style={{
            display: "flex",
            flexDirection: "column",
            gap: 12
            }}
        >
            {dias.map((dia) => {
            const horario = form.horariosLaborales?.[dia.id];

            if (!horario) return null;

            return (
                <div
                key={dia.id}
                style={{
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: 18,
                    padding: 16,
                    boxShadow: "0 2px 8px rgba(15,23,42,0.04)",
                    opacity: horario.activo ? 1 : 0.7
                }}
                >
                {/* ENCABEZADO DEL DÍA */}
                <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 16
                    }}
                >
                    <div
                    style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: "#0f172a"
                    }}
                    >
                    {dia.nombre}
                    </div>

                    <button
                    type="button"
                    onClick={() =>
                        handleHorarioChange(
                        dia.id,
                        "activo",
                        !horario.activo
                        )
                    }
                    style={{
                        width: 50,
                        height: 30,
                        border: "none",
                        borderRadius: 20,
                        padding: 3,
                        background: horario.activo
                        ? "#2563eb"
                        : "#cbd5e1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: horario.activo
                        ? "flex-end"
                        : "flex-start",
                        cursor: "pointer",
                        transition: "all 0.2s"
                    }}
                    >
                    <span
                        style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        background: "#fff",
                        boxShadow:
                            "0 1px 4px rgba(0,0,0,0.2)"
                        }}
                    />
                    </button>
                </div>

                {/* HORARIOS */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        gap: 12,
                        width: "100%",
                        minWidth: 0,
                        boxSizing: "border-box"
                    }}
                >
                    <div
                        style={{
                            width: 0,
                            minWidth: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box"
                        }}
                    >
                        <TimeField
                            label="Apertura"
                            value={horario.apertura || ""}
                            disabled={!horario.activo}
                            onChange={(e) =>
                                handleHorarioChange(
                                    dia.id,
                                    "apertura",
                                    e.target.value
                                )
                            }
                        />
                    </div>

                    <div
                        style={{
                            width: 0,
                            minWidth: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box"
                        }}
                    >
                        <TimeField
                            label="Cierre"
                            value={horario.cierre || ""}
                            disabled={!horario.activo}
                            onChange={(e) =>
                                handleHorarioChange(
                                    dia.id,
                                    "cierre",
                                    e.target.value
                                )
                            }
                        />
                    </div>

                    <div
                        style={{
                            width: 0,
                            minWidth: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box"
                        }}
                    >
                        <TimeField
                            label="Comida inicio"
                            value={horario.comidaInicio || ""}
                            disabled={!horario.activo}
                            onChange={(e) =>
                                handleHorarioChange(
                                    dia.id,
                                    "comidaInicio",
                                    e.target.value
                                )
                            }
                        />
                    </div>

                    <div
                        style={{
                            width: 0,
                            minWidth: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box"
                        }}
                    >
                        <TimeField
                            label="Comida fin"
                            value={horario.comidaFin || ""}
                            disabled={!horario.activo}
                            onChange={(e) =>
                                handleHorarioChange(
                                    dia.id,
                                    "comidaFin",
                                    e.target.value
                                )
                            }
                        />
                    </div>
                </div>

                {!horario.activo && (
                    <div
                        style={{
                            marginTop: 12,
                            fontSize: 13,
                            color: "#64748b",
                            textAlign: "center"
                        }}
                    >
                        Consultorio cerrado este día
                    </div>
                )}
                </div>
            );
            })}
        </div>

        <SaveButton
            saving={saving}
            onClick={guardar}
        />
        </div>
    );
  };

      const renderNotificaciones = () => (

        <div>

        <SectionHeader
            titulo="Notificaciones"
            descripcion="Configura los avisos que recibe el equipo y los que se envían a los pacientes."
            onBack={() =>
            setActiveSection("menu")
            }
        />


        <Card>

            <div style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 6
            }}>

            <BellRing
                size={20}
                strokeWidth={2}
                color="#2563eb"
            />

            <div style={{
                fontSize: 16,
                fontWeight: 700,
                color: "#111827"
            }}>
                Notificaciones en este dispositivo
            </div>

            </div>


            <div style={{
            fontSize: 13,
            color: "#64748b",
            lineHeight: 1.45,
            marginBottom: 4
            }}>
            Controla los avisos que recibes en este
            dispositivo. Cada usuario puede configurar
            sus propias preferencias.
            </div>


            <ToggleRow
            icon={MessageCircle}
            label="Nuevos mensajes de WhatsApp"
            checked={
                userNotificationPreferences
                .whatsappMessages
            }
            onChange={async value => {

                const preferences = {
                ...userNotificationPreferences,
                whatsappMessages: value
                };

                setUserNotificationPreferences(
                preferences
                );

                await updateNotificationPreferences(
                preferences
                );

            }}
            />


            <ToggleRow
            icon={CalendarPlus}
            label="Nuevas citas"
            checked={
                userNotificationPreferences
                .newAppointment
            }
            onChange={async value => {

                const preferences = {
                ...userNotificationPreferences,
                newAppointment: value
                };

                setUserNotificationPreferences(
                preferences
                );

                await updateNotificationPreferences(
                preferences
                );

            }}
            />


            <ToggleRow
            icon={Clock3}
            label="Recordatorio de cita 15 minutos antes"
            checked={
                userNotificationPreferences
                .appointmentReminder15m
            }
            onChange={async value => {

                const preferences = {
                ...userNotificationPreferences,
                appointmentReminder15m: value
                };

                setUserNotificationPreferences(
                preferences
                );

                await updateNotificationPreferences(
                preferences
                );

            }}
            />

        </Card>


        <Card>

            <div style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 6
            }}>

            <UserRound
                size={20}
                strokeWidth={2}
                color="#2563eb"
            />

            <div style={{
                fontSize: 16,
                fontWeight: 700,
                color: "#111827"
            }}>
                Notificaciones para pacientes
            </div>

            </div>


            <div style={{
            fontSize: 13,
            color: "#64748b",
            lineHeight: 1.45,
            marginBottom: 4
            }}>
            Configura los avisos automáticos que VexaDent
            envía a los pacientes del consultorio.
            </div>


            <ToggleRow
            icon={CalendarClock}
            label="Recordatorio 24 horas antes"
            checked={
                form.notifications?.reminder24h
            }
            onChange={value =>
                actualizarNotificacion(
                "reminder24h",
                value
                )
            }
            />


            <ToggleRow
            icon={Clock3}
            label="Recordatorio 2 horas antes"
            checked={
                form.notifications?.reminder2h
            }
            onChange={value =>
                actualizarNotificacion(
                "reminder2h",
                value
                )
            }
            />


            <ToggleRow
            icon={CircleCheck}
            label="Confirmación automática"
            checked={
                form.notifications?.autoConfirm
            }
            onChange={value =>
                actualizarNotificacion(
                "autoConfirm",
                value
                )
            }
            />


            <ToggleRow
            icon={CalendarX2}
            label="Citas canceladas"
            checked={
                form.notifications?.cancelledAppointment
            }
            onChange={value =>
                actualizarNotificacion(
                "cancelledAppointment",
                value
                )
            }
            />

        </Card>


        <SaveButton
            saving={saving}
            onClick={guardar}
        />

        </div>

    );

  const renderIntegraciones = () => (

    <div>

      <SectionHeader
        titulo="Integraciones"
        descripcion="Configura las conexiones externas."
        onBack={() =>
          setActiveSection("menu")
        }
      />


      <Card>

        <CardTitle>
          WhatsApp
        </CardTitle>


        <ToggleRow
          label="WhatsApp habilitado"
          checked={
            form.whatsappEnabled
          }
          onChange={value =>
            actualizarWhatsApp(
              "whatsappEnabled",
              value
            )
          }
        />


        <Field
          label="Nombre de WhatsApp Business"
          value={
            form.whatsappBusinessName
          }
          onChange={event =>
            actualizarWhatsApp(
              "whatsappBusinessName",
              event.target.value
            )
          }
        />


        <Field
          label="Número de WhatsApp"
          value={
            form.whatsappNumber
          }
          onChange={event =>
            actualizarWhatsApp(
              "whatsappNumber",
              event.target.value
            )
          }
          type="tel"
        />

      </Card>


      <SaveButton
        saving={saving}
        onClick={guardar}
      />

    </div>

  );


  function AccountField({
    label,
    value
    }) {

    return (

        <div style={{
        marginBottom: 14
        }}>

        <div style={{
            fontSize: 12,
            fontWeight: 700,
            color: "#64748b",
            marginBottom: 5
        }}>
            {label}
        </div>

        <div style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "12px 13px",
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            background: "#f8fafc",
            color: "#111827",
            fontSize: 15,
            lineHeight: 1.4,
            wordBreak: "break-word"
        }}>
            {value}
        </div>

        </div>

    );

    }

    function getRoleLabel(role) {

        const labels = {
            admin: "Administrador",
            owner: "Administrador / Propietario",
            doctor: "Doctor",
            assistant: "Asistente",
            receptionist: "Recepcionista"
        };

        return labels[role] || role || "Sin rol asignado";

    }

    const cambiarPassword = async () => {

        setPasswordMessage("");
        setPasswordError("");

        const user = auth.currentUser;

        if (!user || !user.email) {

            setPasswordError(
            "No se encontró la cuenta de usuario."
            );

            return;
        }

        if (!currentPassword) {

            setPasswordError(
            "Ingresa tu contraseña actual."
            );

            return;
        }

        if (!newPassword) {

            setPasswordError(
            "Ingresa una nueva contraseña."
            );

            return;
        }

        if (newPassword.length < 8) {

            setPasswordError(
            "La nueva contraseña debe tener al menos 8 caracteres."
            );

            return;
        }

        if (!/[A-Z]/.test(newPassword)) {

            setPasswordError(
            "La nueva contraseña debe contener al menos una letra mayúscula."
            );

            return;
        }

        if (!/[a-z]/.test(newPassword)) {

            setPasswordError(
            "La nueva contraseña debe contener al menos una letra minúscula."
            );

            return;
        }

        if (!/[0-9]/.test(newPassword)) {

            setPasswordError(
            "La nueva contraseña debe contener al menos un número."
            );

            return;
        }

        if (!/[^A-Za-z0-9]/.test(newPassword)) {

            setPasswordError(
            "La nueva contraseña debe contener al menos un carácter especial."
            );

            return;
        }

        if (newPassword !== confirmPassword) {

            setPasswordError(
            "Las contraseñas nuevas no coinciden."
            );

            return;
        }

        setChangingPassword(true);

        try {

            const credential =
            EmailAuthProvider.credential(
                user.email,
                currentPassword
            );

            await reauthenticateWithCredential(
            user,
            credential
            );

            await updatePassword(
            user,
            newPassword
            );

            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");

            setPasswordMessage(
            "Tu contraseña se cambió correctamente."
            );

        } catch (error) {

            console.error(
            "Error cambiando contraseña:",
            error
            );

            if (
            error.code ===
            "auth/invalid-credential" ||
            error.code ===
            "auth/wrong-password"
            ) {

            setPasswordError(
                "La contraseña actual es incorrecta."
            );

            } else if (
            error.code ===
            "auth/too-many-requests"
            ) {

            setPasswordError(
                "Demasiados intentos. Intenta nuevamente más tarde."
            );

            } else {

            setPasswordError(
                "No fue posible cambiar la contraseña. Intenta nuevamente."
            );

            }

        } finally {

            setChangingPassword(false);

        }

    };

    const renderCuenta = () => (

    <div>

        <SectionHeader
        titulo="Mi cuenta"
        descripcion="Configuración de tu cuenta."
        onBack={() =>
            setActiveSection("menu")
        }
        />


        <Card>

        <CardTitle>
            Información de mi cuenta
        </CardTitle>

        <AccountField
            label="Nombre"
            value={
            accountData?.nombre ||
            auth.currentUser?.displayName ||
            "Sin nombre"
            }
        />

        <AccountField
            label="Correo electrónico"
            value={
            accountData?.email ||
            auth.currentUser?.email ||
            "Sin correo"
            }
        />

        <AccountField
            label="Teléfono"
            value={
            accountData?.telefono ||
            "No registrado"
            }
        />

        <AccountField
            label="Rol"
            value={
            getRoleLabel(accountData?.rol)
            }
        />

        </Card>


        <Card>

            <CardTitle>
                Seguridad
            </CardTitle>

            <div style={{
                color: "#64748b",
                fontSize: 14,
                lineHeight: 1.5,
                marginBottom: 18
            }}>
                Cambia la contraseña de tu cuenta.
            </div>


            <div style={{
                marginBottom: 14
            }}>

                <div style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#64748b",
                marginBottom: 6
                }}>
                Contraseña actual
                </div>

                <input
                type="password"
                value={currentPassword}
                onChange={(e) =>
                    setCurrentPassword(e.target.value)
                }
                autoComplete="current-password"
                placeholder="Ingresa tu contraseña actual"
                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "13px 14px",
                    border: "1px solid #e5e7eb",
                    borderRadius: 12,
                    background: "#fff",
                    color: "#111827",
                    fontSize: 15,
                    outline: "none"
                }}
                />

            </div>


            <div style={{
                marginBottom: 14
            }}>

                <div style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#64748b",
                marginBottom: 6
                }}>
                Nueva contraseña
                </div>

                <input
                type="password"
                value={newPassword}
                onChange={(e) =>
                    setNewPassword(e.target.value)
                }
                autoComplete="new-password"
                placeholder="Ingresa tu nueva contraseña"
                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "13px 14px",
                    border: "1px solid #e5e7eb",
                    borderRadius: 12,
                    background: "#fff",
                    color: "#111827",
                    fontSize: 15,
                    outline: "none"
                }}
                />

            </div>


            <div style={{
                marginBottom: 14
            }}>

                <div style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#64748b",
                marginBottom: 6
                }}>
                Confirmar nueva contraseña
                </div>

                <input
                type="password"
                value={confirmPassword}
                onChange={(e) =>
                    setConfirmPassword(e.target.value)
                }
                autoComplete="new-password"
                placeholder="Repite tu nueva contraseña"
                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "13px 14px",
                    border: "1px solid #e5e7eb",
                    borderRadius: 12,
                    background: "#fff",
                    color: "#111827",
                    fontSize: 15,
                    outline: "none"
                }}
                />

            </div>


            <div style={{
                padding: "12px 14px",
                marginBottom: 16,
                borderRadius: 12,
                background: "#f8fafc",
                color: "#64748b",
                fontSize: 13,
                lineHeight: 1.5
            }}>
                La contraseña debe tener al menos 8 caracteres,
                una mayúscula, una minúscula, un número y
                un carácter especial.
            </div>


            {passwordError && (

                <div style={{
                marginBottom: 14,
                padding: "11px 13px",
                borderRadius: 10,
                background: "#fef2f2",
                color: "#dc2626",
                fontSize: 13,
                lineHeight: 1.4
                }}>
                {passwordError}
                </div>

            )}


            {passwordMessage && (

                <div style={{
                marginBottom: 14,
                padding: "11px 13px",
                borderRadius: 10,
                background: "#f0fdf4",
                color: "#16a34a",
                fontSize: 13,
                lineHeight: 1.4
                }}>
                {passwordMessage}
                </div>

            )}


            <button
                type="button"
                onClick={cambiarPassword}
                disabled={changingPassword}
                style={{
                width: "100%",
                padding: "13px 16px",
                border: "none",
                borderRadius: 14,
                background: changingPassword
                    ? "#94a3b8"
                    : "#2563eb",
                color: "#fff",
                fontSize: 15,
                fontWeight: 800,
                cursor: changingPassword
                    ? "default"
                    : "pointer"
                }}
            >
                {changingPassword
                ? "Cambiando contraseña..."
                : "Cambiar contraseña"}
            </button>

        </Card>

    </div>

  );

  const renderSistema = () => (

    <div>

        <SectionHeader
        titulo="Sistema"
        descripcion="Información y estado del sistema."
        onBack={() =>
            setActiveSection("menu")
        }
        />


        <Card>

        <CardTitle>
            Vista previa de firma
        </CardTitle>

        <div style={{
            background: "#f8fafc",
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            padding: 16,
            whiteSpace: "pre-wrap",
            color: "#111827",
            fontSize: 14,
            lineHeight: 1.5
        }}>

            {
            systemUserSettings
                .useCustomSignature
                ? (
                    systemUserSettings
                    .firmaPersonalizada ||
                    "Sin firma personalizada"
                )
                : (
                    `${form.nombreClinica || ""}\n${
                    accountData?.nombre ||
                    auth.currentUser?.displayName ||
                    ""
                    }`
                )
            }

        </div>

        </Card>


        <Card>

        <CardTitle>
            Estado del sistema
        </CardTitle>


        <SystemStatusRow
            label="Versión"
            value="1.0.5"
        />


        <SystemStatusRow
            label="Firebase"
            value="Conectado"
            status="success"
        />


        <SystemStatusRow
            label="WhatsApp VPS"
            value={
            vpsOnline
                ? "Online"
                : "Offline"
            }
            status={
            vpsOnline
                ? "success"
                : "error"
            }
        />


        <SystemStatusRow
            label="Sesión WhatsApp"
            value={
            clinicData?.whatsapp?.connected
                ? "Conectada"
                : "Desconectada"
            }
            status={
            clinicData?.whatsapp?.connected
                ? "success"
                : "error"
            }
        />


        <SystemStatusRow
            label="Número"
            value={
            clinicData?.whatsapp?.phoneNumber ||
            "-"
            }
        />


        <SystemStatusRow
            label="Google Calendar"
            value={
            googleCalendarSystem.connected
                ? "Conectado"
                : "Desconectado"
            }
            status={
            googleCalendarSystem.connected
                ? "success"
                : "error"
            }
        />

        </Card>


        <Card>

        <button
            type="button"
            onClick={() =>
            setShowMobileAppModal(true)
            }
            style={{
            width: "100%",
            border: "none",
            background: "transparent",
            padding: 0,
            textAlign: "left",
            cursor: "pointer"
            }}
        >

            <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 14
            }}>

            <div>

                <div style={{
                fontSize: 16,
                fontWeight: 800,
                color: "#111827",
                marginBottom: 5
                }}>
                Aplicación móvil
                </div>

                <div style={{
                color: "#64748b",
                fontSize: 14,
                lineHeight: 1.4
                }}>
                Instala VexaDent en tus dispositivos.
                </div>

            </div>

            <div style={{
                color: "#94a3b8",
                fontSize: 24
            }}>
                →
            </div>

            </div>

        </button>

        </Card>


        {showMobileAppModal && (

        <div
            style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 20,
            zIndex: 99999
            }}
            onClick={() =>
            setShowMobileAppModal(false)
            }
        >

            <div
            style={{
                width: "100%",
                maxWidth: 420,
                background: "#fff",
                borderRadius: 20,
                padding: 22,
                boxSizing: "border-box",
                maxHeight: "90vh",
                overflowY: "auto"
            }}
            onClick={event =>
                event.stopPropagation()
            }
            >

            <div style={{
                fontSize: 20,
                fontWeight: 800,
                color: "#111827",
                marginBottom: 8
            }}>
                Aplicación móvil
            </div>


            <div style={{
                color: "#64748b",
                fontSize: 14,
                lineHeight: 1.5,
                marginBottom: 20
            }}>
                Instala VexaDent en todos tus
                dispositivos utilizando tu cuenta.
            </div>


            <div style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 18
            }}>

                <QRCodeSVG
                value="https://app.vexadent.com"
                size={200}
                />

            </div>


            <div style={{
                textAlign: "center",
                fontSize: 13,
                fontWeight: 700,
                color: "#374151",
                marginBottom: 20,
                wordBreak: "break-all"
            }}>
                https://app.vexadent.com
            </div>


            <div style={{
                marginBottom: 18,
                color: "#374151",
                fontSize: 14,
                lineHeight: 1.6
            }}>

                <strong>
                Android
                </strong>

                <br />

                • Escanea el QR.
                <br />
                • Presiona Instalar.

            </div>


            <div style={{
                marginBottom: 20,
                color: "#374151",
                fontSize: 14,
                lineHeight: 1.6
            }}>

                <strong>
                iPhone
                </strong>

                <br />

                • Escanea el QR.
                <br />
                • Presiona Compartir.
                <br />
                • Selecciona Agregar a pantalla de inicio.

            </div>


            <button
                type="button"
                onClick={() =>
                setShowMobileAppModal(false)
                }
                style={{
                width: "100%",
                padding: 14,
                border: "none",
                borderRadius: 12,
                background: "#2563eb",
                color: "#fff",
                fontWeight: 800,
                fontSize: 15,
                cursor: "pointer"
                }}
            >
                Cerrar
            </button>

            </div>

        </div>

        )}

    </div>

  );

  const renderSectionPlaceholder = (
    titulo,
    descripcion
  ) => (

    <div>

      <SectionHeader
        titulo={titulo}
        descripcion={descripcion}
        onBack={() =>
          setActiveSection("menu")
        }
      />


      <Card>

        <div style={{
          textAlign: "center",
          padding: "28px 10px",
          color: "#64748b",
          lineHeight: 1.6
        }}>

          Esta sección ya existe en
          VexaDent y será adaptada a
          la interfaz móvil sin modificar
          su configuración actual.

        </div>

      </Card>

    </div>

  );


  return (

    <div className="vd-mobile-settings" style={{
      width: "100%",
      boxSizing: "border-box",
      paddingBottom: 30
    }}>

      {message && (

        <div
          style={{
            marginBottom: 14,
            padding: 14,
            borderRadius: 14,
            background:
              message.type === "success"
                ? "#dcfce7"
                : "#fee2e2",
            color:
              message.type === "success"
                ? "#166534"
                : "#991b1b",
            fontWeight: 700,
            fontSize: 14
          }}
        >

          {message.text}

        </div>

      )}


      {activeSection === "menu" ? (

        <>

          <div className="vd-mobile-settings-heading" style={{
            marginBottom: 18
          }}>

            <div style={{
              fontSize: 24,
              fontWeight: 800,
              color: "#111827"
            }}>
              Ajustes
            </div>

            <div style={{
              marginTop: 5,
              color: "#64748b",
              fontSize: 14
            }}>
              Configura tu consultorio
            </div>

          </div>


          <div className="vd-mobile-settings-list" style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}>

            {secciones.map(
              seccion => (

                <button
                  key={seccion.id}
                  type="button"
                  className="vd-mobile-settings-card"
                  onClick={() =>
                    setActiveSection(
                      seccion.id
                    )
                  }
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    padding: 16,
                    border:
                      "1px solid #e5e7eb",
                    borderRadius: 16,
                    background: "#fff",
                    textAlign: "left",
                    boxShadow:
                      "0 2px 8px rgba(15,23,42,.04)",
                    cursor: "pointer"
                  }}
                >

                  <div style={{
                    width: 46,
                    height: 46,
                    borderRadius: 14,
                    background: "#eff6ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#2563eb",
                    flexShrink: 0
                    }}>
                    <seccion.icono
                        size={22}
                        strokeWidth={1.8}
                    />
                  </div>


                  <div style={{
                    flex: 1,
                    minWidth: 0
                  }}>

                    <div style={{
                      fontWeight: 800,
                      color: "#111827",
                      fontSize: 15
                    }}>
                      {seccion.titulo}
                    </div>

                    <div style={{
                      marginTop: 3,
                      color: "#64748b",
                      fontSize: 13,
                      lineHeight: 1.35
                    }}>
                      {seccion.descripcion}
                    </div>

                  </div>


                  <div style={{
                    color: "#94a3b8",
                    display: "flex",
                    alignItems: "center"
                    }}>
                    <ChevronRight
                        size={21}
                        strokeWidth={1.8}
                    />
                  </div>

                </button>

              )
            )}

          </div>

        </>

      ) : (

        <>

          {activeSection === "general" &&
            renderGeneral()}

          {activeSection === "control" && (
            <AdvancedClinicSettings />
          )}

          {activeSection === "horarios" &&
            renderHorarios()}

          {activeSection === "notificaciones" &&
            renderNotificaciones()}

          {activeSection === "integraciones" && (
            <div className="vd-mobile-specialized-panel"><MobileIntegracionesSettings /></div>
            )}

          {activeSection === "cuenta" &&
            renderCuenta()}

          {activeSection === "procedimientos" && (
            <div className="vd-mobile-specialized-panel"><MobileProceduresSettings /></div>
            )}

          {activeSection === "historia" && (
            <div className="vd-mobile-specialized-panel"><MobileHistoriaClinicaSettings /></div>
            )}

          {activeSection === "consentimientos" && (
            <div className="vd-mobile-specialized-panel"><MobileConsentimientosSettings /></div>
            )}
          
          {activeSection === "comunicacion" && (
              <div className="vd-mobile-specialized-panel"><ComunicacionCampanasPanel /></div>
            )}  

          {activeSection === "medicamentos" && (
            <div className="vd-mobile-specialized-panel"><MobileMedicamentosSettings /></div>
            )}

          {activeSection === "sistema" &&
            renderSistema()}

        </>

      )}

    </div>

  );

}

function SectionHeader({
  titulo,
  descripcion,
  onBack
}) {

  return (

    <div style={{
      marginBottom: 16
    }}>

      <button
        type="button"
        onClick={onBack}
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          color: "#2563eb",
          fontWeight: 700,
          fontSize: 14,
          cursor: "pointer",
          marginBottom: 14
        }}
      >
        ← Ajustes
      </button>


      <div style={{
        fontSize: 23,
        fontWeight: 800,
        color: "#111827"
      }}>
        {titulo}
      </div>


      <div style={{
        marginTop: 5,
        color: "#64748b",
        fontSize: 14,
        lineHeight: 1.4
      }}>
        {descripcion}
      </div>

    </div>

  );

}


function Card({
  children
}) {

  return (

    <div style={{
      background: "#fff",
      border:
        "1px solid #e5e7eb",
      borderRadius: 18,
      padding: 16,
      marginBottom: 14,
      boxShadow:
        "0 2px 8px rgba(15,23,42,.04)"
    }}>

      {children}

    </div>

  );

}


function CardTitle({
  children
}) {

  return (

    <div style={{
      fontSize: 16,
      fontWeight: 800,
      color: "#111827",
      marginBottom: 14
    }}>

      {children}

    </div>

  );

}

function SystemStatusRow({
  label,
  value,
  status
}) {

  const statusColor =
    status === "success"
      ? "#16a34a"
      : status === "error"
        ? "#dc2626"
        : "#64748b";

  return (

    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "12px 0",
      borderBottom: "1px solid #f1f5f9"
    }}>

      <div style={{
        fontSize: 14,
        fontWeight: 600,
        color: "#374151"
      }}>
        {label}
      </div>

      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        fontSize: 14,
        fontWeight: 700,
        color: statusColor,
        textAlign: "right"
      }}>

        {status && (

          <div style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: statusColor,
            flexShrink: 0
          }} />

        )}

        {value}

      </div>

    </div>

  );

}

function Field({
  label,
  value,
  onChange,
  name,
  type = "text"
}) {

  return (

    <div style={{
      marginBottom: 14
    }}>

      <label style={{
        display: "block",
        fontSize: 13,
        fontWeight: 700,
        color: "#374151",
        marginBottom: 7
      }}>

        {label}

      </label>


      <input
        name={name}
        type={type}
        value={value || ""}
        onChange={onChange}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding:
            "12px 13px",
          border:
            "1px solid #d1d5db",
          borderRadius: 12,
          background: "#fff",
          color: "#111827",
          fontSize: 15,
          outline: "none"
        }}
      />

    </div>

  );

}


function SelectField({
  label,
  value,
  onChange,
  name,
  options
}) {

  return (

    <div style={{
      marginBottom: 14
    }}>

      <label style={{
        display: "block",
        fontSize: 13,
        fontWeight: 700,
        color: "#374151",
        marginBottom: 7
      }}>

        {label}

      </label>


      <select
        name={name}
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding:
            "12px 13px",
          border:
            "1px solid #d1d5db",
          borderRadius: 12,
          background: "#fff",
          color: "#111827",
          fontSize: 15
        }}
      >

        {options.map(
          ([valueOption, labelOption]) => (

            <option
              key={valueOption}
              value={valueOption}
            >
              {labelOption}
            </option>

          )
        )}

      </select>

    </div>

  );

}


function TimeField({
    label,
    value,
    onChange,
    disabled
}) {

    return (

        <div
            style={{
                width: "100%",
                minWidth: 0,
                maxWidth: "100%",
                boxSizing: "border-box"
            }}
        >

            <label
                style={{
                    display: "block",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#64748b",
                    marginBottom: 6
                }}
            >
                {label}
            </label>

            <div
                style={{
                    position: "relative",
                    width: "100%",
                    minWidth: 0,
                    maxWidth: "100%",
                    overflow: "hidden",
                    boxSizing: "border-box"
                }}
            >

                <input
                    type="time"
                    value={value || ""}
                    onChange={onChange}
                    disabled={disabled}
                    style={{
                        display: "block",
                        width: "100%",
                        minWidth: 0,
                        maxWidth: "100%",
                        height: 48,
                        boxSizing: "border-box",
                        appearance: "none",
                        WebkitAppearance: "none",
                        padding: "0 42px 0 10px",
                        border: "1px solid #d1d5db",
                        borderRadius: 11,
                        background: disabled
                            ? "#f1f5f9"
                            : "#fff",
                        fontSize: 16,
                        fontFamily: "inherit"
                    }}
                />

                {!disabled && value && (
                    <button
                        type="button"
                        onClick={() =>
                            onChange({
                                target: {
                                    value: ""
                                }
                            })
                        }
                        style={{
                            position: "absolute",
                            right: 7,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: 32,
                            height: 32,
                            border: "none",
                            borderRadius: 9,
                            background: "#f1f5f9",
                            color: "#64748b",
                            fontSize: 22,
                            lineHeight: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 0,
                            zIndex: 2
                        }}
                        aria-label={`Borrar ${label}`}
                    >
                        ×
                    </button>
                )}

            </div>

        </div>

    );

}

function ToggleRow({
  icon: Icon,
  label,
  checked,
  onChange
}) {

  return (

    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent:
        "space-between",
      gap: 14,
      padding:
        "14px 0",
      borderBottom:
        "1px solid #e5e7eb"
    }}>

      <div style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 14,
        fontWeight: 600,
        color: "#111827"
        }}>

        {Icon && (
            <Icon
            size={19}
            strokeWidth={2}
            color="#64748b"
            style={{
                flexShrink: 0
            }}
            />
        )}

        <span>
            {label}
        </span>

      </div>


      <button
        type="button"
        onClick={() =>
          onChange(!checked)
        }
        style={{
          width: 48,
          height: 28,
          borderRadius: 999,
          border: "none",
          padding: 3,
          background:
            checked
              ? "#2563eb"
              : "#cbd5e1",
          cursor: "pointer",
          position: "relative",
          flexShrink: 0
        }}
      >

        <span
          style={{
            display: "block",
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "#fff",
            transform:
              checked
                ? "translateX(20px)"
                : "translateX(0)",
            transition:
              "transform .2s"
          }}
        />

      </button>

    </div>

  );

}


function SaveButton({
  saving,
  onClick
}) {

  return (

    <button
      type="button"
      onClick={onClick}
      disabled={saving}
      style={{
        width: "100%",
        padding: "14px 16px",
        border: "none",
        borderRadius: 14,
        background:
          saving
            ? "#93c5fd"
            : "#2563eb",
        color: "#fff",
        fontSize: 15,
        fontWeight: 800,
        cursor:
          saving
            ? "default"
            : "pointer",
        marginTop: 4
      }}
    >

      {saving
        ? "Guardando..."
        : "Guardar cambios"}

    </button>

  );

}
